import { render, staticRenderFns } from "./DeviceFaultType.vue?vue&type=template&id=52a5d688&scoped=true"
import script from "./DeviceFaultType.vue?vue&type=script&lang=js"
export * from "./DeviceFaultType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5d688",
  null
  
)

export default component.exports